import cn from "clsx";
import {
  BaseLayout,
  SiteHeaderComponent,
} from "design-system/components/layouts/base";
import {
  ArchivePageBody,
  ArchivePageBodyProps,
} from "./archive-page-body/archive-page-body";
import { BreadcrumbsProps } from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import { SiteFooterProps } from "design-system/components/universal/site-footer/site-footer";
import { ExtractLazyComponent } from "design-system/components/system/lazy-component/lazy-component";
import { SimpleTheme } from "design-system/utils/theme";

export type ArchivePageTopper = ExtractLazyComponent<
  | "CardTopper"
  | "SimplePageTopper"
  | "MediaTopper"
  | "SearchTopper"
  | "SplitTopper"
  | "StatisticsTopper"
  | "SelectTopper"
  | "FeaturedTermTopper"
>;

export interface ArchivePageProps {
  breadcrumbs?: BreadcrumbsProps;
  footer?: SiteFooterProps;
  header?: SiteHeaderComponent;
  topper?: ArchivePageTopper;
  body?: ArchivePageBodyProps;
  theme?: SimpleTheme;
}

export function ArchivePage({
  body,
  breadcrumbs,
  footer,
  header,
  topper,
  theme,
}: ArchivePageProps) {
  const layoutClass = cn(
    "hbs-page",
    "hbs-archive-page",
    topper?.name && `hbs-page--${topper.name}`,
  );

  const gtmPageEvent = {
    storyID: "archive-page-123",
    pubDate: "2022-10-24",
    storyType: "Archive",
  };

  return (
    <BaseLayout
      className={layoutClass}
      footer={footer}
      header={header}
      gtmPageEvent={gtmPageEvent}
    >
      {body && (
        <ArchivePageBody
          breadcrumbs={breadcrumbs}
          topper={topper}
          theme={theme}
          {...body}
        />
      )}
    </BaseLayout>
  );
}
